"use strict";

angular.module("core")
.constant("PRODUCT_TYPES", {
    "STANDARD": "standard",
    "DISTRIBUTION": "distribution",
    "DEPOSIT": "deposit",
});



//////////////////
// WEBPACK FOOTER
// ./core/product/product.constants.js
// module id = 398
// module chunks = 0